import * as React from "react"

const ReduceCosts = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 195.57 373.82"
    {...props}
  >
    <title>{"Reduce-Shipping-Costs-2"}</title>
    <path
      fill="#00b08e"
      d="M97.79 373.82 0 317.36V204.45l97.79 56.45v112.92z"
    />
    <path
      fill="#007f6e"
      d="M195.57 204.45v112.91l-97.79 56.46V260.9l97.79-56.45z"
    />
    <path
      fill="#fff"
      d="m163.28 223.19-.07 56.33 5.67-3.28-16.6 40.87-22.34-18.24 5.84-3.44.13-56.48 27.37-15.76z"
    />
    <path
      fill="#b1da00"
      d="m195.57 204.58-97.79-56.33L0 204.58l97.78 56.32 97.79-56.32z"
    />
    <path
      fill="#fff"
      d="m163.28 223.19-98.14-56.36-27.58 15.9 98.35 56.22 27.37-15.76z"
    />
    <path
      fill="#00b08e"
      d="m98.09 233.12-73.34-42.35v-84.68l73.34 42.34v84.69z"
    />
    <path
      fill="#007f6e"
      d="M171.43 106.09v84.68l-73.34 42.35v-84.69l73.34-42.34z"
    />
    <path
      fill="#fff"
      d="m147.21 120.14-.05 34.64-20.58 11.93.11-34.74 20.52-11.83z"
    />
    <path
      fill="#b1da00"
      d="M171.43 106.19 98.09 63.95l-73.34 42.24 73.34 42.24 73.34-42.24z"
    />
    <path
      fill="#fff"
      d="m147.21 120.14-73.6-42.26-20.69 11.93 73.77 42.16 20.52-11.83z"
    />
    <path
      fill="#fff"
      d="m147.36 119.86-.05 35.06 4.31-2.49-12.61 31.03-16.96-13.84 4.43-2.62.11-35.17 20.77-11.97z"
    />
    <path
      fill="#00b08e"
      d="M97.48 126.88 42.47 95.12V31.61l55.01 31.76v63.51z"
    />
    <path
      fill="#007f6e"
      d="M152.48 31.61v63.51l-55 31.76-.01-63.51 55.01-31.76z"
    />
    <path
      fill="#fff"
      d="m134.32 42.15-.04 25.97-15.43 8.95.08-26.05 15.39-8.87z"
    />
    <path
      fill="#b1da00"
      d="M152.48 31.68 97.48 0 42.47 31.68l55.01 31.69 55-31.69z"
    />
    <path
      fill="#fff"
      d="m134.32 42.15-55.21-31.7-15.51 8.94 55.33 31.63 15.39-8.87z"
    />
    <path
      fill="#fff"
      d="m134.45 41.98-.04 26.21 3.22-1.86-9.42 23.19-12.68-10.35 3.31-1.95.08-26.29 15.53-8.95z"
    />
  </svg>
)

export default ReduceCosts
